export default __webpack_public_path__ + "static/media/google-pay-mark.62f7b52d.svg";